import { Typography } from '@material-ui/core'
import RatePlanIcon from '@material-ui/icons/ImageSearch'
import { useParams } from 'react-router-dom'

import { getTranslate } from '../../localization'
import useStyles from './styles/RateplanAddHeader.styles'

export const RateplanAddHeader = () => {
  const classes = useStyles()
  const params = useParams<{ id: string }>()

  return (
    <div className={classes.header}>
      <RatePlanIcon fontSize="large" />
      <Typography className={classes.title} variant="h3" gutterBottom>
        {getTranslate(params.id ? 'Edit Rate Plan' : 'Add New Rate Plan')}
      </Typography>
    </div>
  )
}
